export default "__VITE_ASSET__Bm3aK3Co__"